import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { Flex } from "../Flex/Flex";
import { withFormWrapper } from "../withFormWrapper";
import parseChildren from "../utils/parseChildren";
import { View } from "../View/View";
import { UtilityStyle } from "../hooks/useUtilityStyles";
export const RawFieldGroup = observer((props) => {
    const fieldChildren = parseChildren(props?.children);
    return (React.createElement(Flex, { direction: "row", gap: "small", alignItems: "stretch" }, fieldChildren.map((fieldChild, i) => {
        return (React.createElement(FieldGroupChild, { fieldChild: fieldChild, ...props, key: i, position: i }));
    })));
});
const FieldGroupChild = (props) => {
    const { fieldChild } = props;
    const childProps = fieldChild.props;
    const renderChildComponent = useMemo(() => ({
        ...fieldChild,
        props: {
            ...childProps,
            ariaLabelledby: props?.describingId,
            labelRemoved: true,
            name: `${props?.name}.${childProps.name}`,
            styleOptions: [UtilityStyle.BottomSpaceZero],
        },
    }), [fieldChild]);
    return (React.createElement(View, { flex: props?.childFlex ? props?.childFlex[props?.position] : 1, position: "relative" }, renderChildComponent));
};
export const FieldGroup = withFormWrapper({
    WrappedComponent: RawFieldGroup,
    options: "objectValidation",
});
